import styled from 'styled-components';

export const ContainerDetalhes = styled.div`
  /* Auto layout */
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  gap: 32px;

  background: #ffffff;
  border-radius: 8px;
`;

export const Container = styled.div`
  /* Auto layout */
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`;

export const Row = styled.div`
  /* Auto layout */
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: calc(1rem + 10%);
`;

export const Item = styled.div`
  min-width: 200px;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;
